var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_2849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5846 7.5013C12.5846 8.92804 11.428 10.0846 10.0013 10.0846V11.5846C12.2565 11.5846 14.0846 9.75646 14.0846 7.5013H12.5846ZM10.0013 10.0846C8.57457 10.0846 7.41797 8.92804 7.41797 7.5013H5.91797C5.91797 9.75646 7.74614 11.5846 10.0013 11.5846V10.0846ZM7.41797 7.5013C7.41797 6.07457 8.57457 4.91797 10.0013 4.91797V3.41797C7.74614 3.41797 5.91797 5.24614 5.91797 7.5013H7.41797ZM10.0013 4.91797C11.428 4.91797 12.5846 6.07457 12.5846 7.5013H14.0846C14.0846 5.24614 12.2565 3.41797 10.0013 3.41797V4.91797ZM7.5013 14.0846H12.5013V12.5846H7.5013V14.0846ZM2.41797 10.0013C2.41797 5.81314 5.81314 2.41797 10.0013 2.41797V0.917969C4.98472 0.917969 0.917969 4.98472 0.917969 10.0013H2.41797ZM10.0013 2.41797C14.1895 2.41797 17.5846 5.81314 17.5846 10.0013H19.0846C19.0846 4.98472 15.0179 0.917969 10.0013 0.917969V2.41797ZM17.5846 10.0013C17.5846 12.1519 16.6903 14.0925 15.2513 15.4735L16.2899 16.5557C18.0115 14.9036 19.0846 12.5771 19.0846 10.0013H17.5846ZM15.2513 15.4735C13.8881 16.7817 12.0392 17.5846 10.0013 17.5846V19.0846C12.4417 19.0846 14.6586 18.1213 16.2899 16.5557L15.2513 15.4735ZM12.5013 14.0846C13.7539 14.0846 14.7997 14.9768 15.035 16.1608L16.5062 15.8684C16.1341 13.9961 14.4834 12.5846 12.5013 12.5846V14.0846ZM10.0013 17.5846C7.96338 17.5846 6.11455 16.7817 4.75129 15.4735L3.71267 16.5557C5.34403 18.1213 7.56095 19.0846 10.0013 19.0846V17.5846ZM4.75129 15.4735C3.31226 14.0925 2.41797 12.1519 2.41797 10.0013H0.917969C0.917969 12.5771 1.99112 14.9036 3.71267 16.5557L4.75129 15.4735ZM7.5013 12.5846C5.51922 12.5846 3.86846 13.9961 3.49637 15.8684L4.96759 16.1608C5.20289 14.9768 6.24873 14.0846 7.5013 14.0846V12.5846Z",
    fill: "url(#paint0_radial_100_2849)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_100_2849",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.87122 17.0526) rotate(-41.5346) scale(21.9936 59.2787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_2849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.01d38a88445a1abd7a06f30f06f1db64.svg";
export { ForwardRef as ReactComponent };